<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes da Operação"
    show-back
    back-aria-label="Fechar detalhes da operação">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="operation-details-drawer" *ngIf="!isLoading; else loadingState">
      <b3-tag
        size="sm"
        variant="filled"
        [icon]="operationTypeBadge.icon"
        [tone]="operationTypeBadge.tone"
        [label]="operationTypeBadge.label">
      </b3-tag>

      <ng-container *ngIf="isAcxMode; else b3RetirementDetails">
        <div class="operation-details-drawer__field operation-details-drawer__field--full">
          <span class="operation-details-drawer__label">Informação</span>
          <span class="operation-details-drawer__value">
            Consulta a plataforma ACX para mais informações
          </span>
        </div>
      </ng-container>

      <ng-template #b3RetirementDetails>
        <div class="operation-details-drawer__entities-header">
          <span class="operation-details-drawer__entities-title">Entidades incluídas</span>
          <span
            class="operation-details-drawer__entities-count"
            [attr.aria-label]="'Quantidade de entidades incluídas: ' + entitiesCountLabel">
            {{ entitiesCountLabel }}
          </span>
        </div>

        <article
          *ngFor="let entity of entities; let index = index"
          class="operation-details-drawer__entity-card"
          [attr.aria-label]="'Entidade ' + (index + 1)">
          <div class="operation-details-drawer__grid operation-details-drawer__grid--2">
            <div class="operation-details-drawer__field">
              <span class="operation-details-drawer__label">Motivo da retirada</span>
              <span class="operation-details-drawer__value">{{ entity.withdrawalReason }}</span>
            </div>
            <div class="operation-details-drawer__field">
              <span class="operation-details-drawer__label">Aposentadoria em nome de</span>
              <span class="operation-details-drawer__value">{{ entity.retirementOnBehalfOf }}</span>
            </div>
          </div>

          <div class="operation-details-drawer__grid operation-details-drawer__grid--2">
            <div class="operation-details-drawer__field">
              <span class="operation-details-drawer__label">{{ entity.documentLabel }}</span>
              <span class="operation-details-drawer__value">{{ entity.documentNumber }}</span>
            </div>
            <div class="operation-details-drawer__field">
              <span class="operation-details-drawer__label">Quantidade</span>
              <span class="operation-details-drawer__value">{{ entity.quantity }}</span>
            </div>
          </div>

          <div class="operation-details-drawer__field operation-details-drawer__field--full">
            <span class="operation-details-drawer__label">Nome/Razão Social</span>
            <span class="operation-details-drawer__value">{{ entity.companyName }}</span>
          </div>

          <div class="operation-details-drawer__field operation-details-drawer__field--full">
            <span class="operation-details-drawer__label">Descrição dos detalhes</span>
            <p class="operation-details-drawer__value operation-details-drawer__value--description">
              {{ entity.detailsDescription }}
            </p>
          </div>
        </article>
      </ng-template>

      <div class="operation-details-drawer__actions">
        <b3-button
          class="operation-details-drawer__confirm-btn"
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="close()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Entendi
        </b3-button>
      </div>
    </div>

    <ng-template #loadingState>
      <p class="operation-details-drawer__loading">Carregando detalhes da operação...</p>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>
